module.exports = {
  getSubscriptions: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'subscriptions'
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      console.log(response.data)
      commit('setSubscription', response.data)
      return null
    } else {
      return response.message
    }
  }, 
  getAvailableSubscriptions: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'subscriptions/available'
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setAvailableSubscriptions', response.data.subscriptions)
      return null
    } else {
      return response.message
    }
  },
}
